/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Spelling_Numbers_FailedInputs */

const en_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spelling numbers #0-10 failed. ${i?.error}`)
};

const fr_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Épellation des chiffres #0-10 échouée. ${i?.error}`)
};

const de_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Eingabe der Zahlen 0-10 ist fehlgeschlagen. ${i?.error}`)
};

const it_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore nell'ortografia dei numeri da 0 a 10. ${i?.error}`)
};

const ru_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Неправильное написание цифр от 0 до 10. ${i?.error}`)
};

const es_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al deletrear los números del 0 al 10. ${i?.error}`)
};

const zh_cn2_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`数字 0-10 拼写错误。${i?.error}`)
};

const ja_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`数字 #0-10 のスペルに失敗しました。${i?.error}`)
};

const hi_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`संख्या 0-10 की वर्तनी में त्रुटि हुई। ${i?.error}`)
};

const pt_pt2_spelling_numbers_failed = /** @type {(inputs: Spelling_Numbers_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A soletração dos números de 0 a 10 falhou. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Spelling numbers #0-10 failed. {error}" |
*
* @param {Spelling_Numbers_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spelling_numbers_failed = /** @type {((inputs: Spelling_Numbers_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spelling_Numbers_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spelling_numbers_failed(inputs)
	if (locale === "de") return de_spelling_numbers_failed(inputs)
	if (locale === "it") return it_spelling_numbers_failed(inputs)
	if (locale === "ru") return ru_spelling_numbers_failed(inputs)
	if (locale === "es") return es_spelling_numbers_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_spelling_numbers_failed(inputs)
	if (locale === "ja") return ja_spelling_numbers_failed(inputs)
	if (locale === "hi") return hi_spelling_numbers_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_spelling_numbers_failed(inputs)
	return en_spelling_numbers_failed(inputs)
});